var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgRedditAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "secondary",
  fill: "#ff4500"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96.781 107.306c-3.582 3.582-11.248 4.86-16.716 4.86s-13.135-1.278-16.717-4.86a2.161 2.161 0 0 0-3.057 3.057c5.684 5.671 16.574 6.113 19.786 6.113s14.101-.442 19.797-6.113a2.174 2.174 0 1 0-3.093-3.057Z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61.665,
  cy: 88.357,
  r: 8.358
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98.345,
  cy: 88.357,
  r: 8.358
}), /*#__PURE__*/React.createElement("path", {
  d: "M80 0a80 80 0 1 0 80 80A80 80 0 0 0 80 0Zm46.393 90.816a22.95 22.95 0 0 1 .275 3.51c0 17.947-20.908 32.502-46.675 32.502S33.33 112.238 33.33 94.327a23.136 23.136 0 0 1 .275-3.582A11.654 11.654 0 1 1 46.453 71.64c8.047-5.874 19.236-9.552 31.618-9.898l5.97-27.905a2.102 2.102 0 0 1 .907-1.313 2.065 2.065 0 0 1 1.564-.287l19.368 4.12a8.358 8.358 0 1 1-.848 4.071l-17.373-3.69-5.313 25.003c12.238.43 23.223 4.144 31.2 9.899a11.707 11.707 0 1 1 12.847 19.176Z"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "snoo",
  fill: "#fff",
  d: "M133.306 79.999a11.666 11.666 0 0 0-19.76-8.359c-7.977-5.755-18.962-9.469-31.2-9.899l5.313-25.002 17.373 3.69a8.358 8.358 0 1 0 .847-4.072l-19.367-4.12a2.066 2.066 0 0 0-1.564.287 2.102 2.102 0 0 0-.907 1.313l-5.97 27.905c-12.382.346-23.57 4.024-31.618 9.898a11.654 11.654 0 1 0-12.848 19.105 23.122 23.122 0 0 0-.275 3.582c0 17.91 20.896 32.501 46.663 32.501s46.675-14.555 46.675-32.501a22.95 22.95 0 0 0-.275-3.51 11.666 11.666 0 0 0 6.913-10.818Zm-80 8.358a8.358 8.358 0 1 1 8.359 8.358 8.358 8.358 0 0 1-8.359-8.358Zm46.568 22.006c-5.696 5.671-16.585 6.113-19.797 6.113s-14.102-.442-19.785-6.113a2.161 2.161 0 0 1 3.056-3.057c3.582 3.582 11.248 4.86 16.717 4.86s13.134-1.278 16.716-4.86a2.174 2.174 0 0 1 3.093 3.057Zm-1.529-13.648a8.358 8.358 0 1 1 8.358-8.358 8.358 8.358 0 0 1-8.358 8.358Z"
})));

export default SvgRedditAlt;